const permissions = {
  clientId: '归属系统',
  menuId:'归属模块',
  permissionKey:'权限KEY',
  permissionName:'权限名称',
  permissionType:'权限类型',
  activeOff:'是否可用',
  remark:'备注',
  addPermission:'新增权限',
  editPermission:'修改权限',
  bindButton:'绑定按钮',
  buttonPermission:'按钮权限',
  normalPermission:'普通权限',
  msg:{
    clientId:'请选择归属系统',
    menuId:"请选择归属模块",
    permissionKey:'请输入权限KEY',
    permissionName:'请输入权限名称',
    permissionType:"请选择权限类型"
  }
};
export default permissions



// WEBPACK FOOTER //
// ./src/page/auth/permission/lang/permissions.zh.js